<template>
  <iframe onload="this.style.height=(this.contentWindow.document.body.scrollHeight+20)+'px';" class="w-full" :srcdoc="previewContent"></iframe>
</template>

<script>
export default {
  name: "EmailPreview",
  props: [
      'previewContent'
  ]
}
</script>
